import { FC, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import { CustomDropdown } from '../../molecules';
import styles from './LandscapeAboutCommittedBuyersPartnerOrganism.module.css';
import cn from 'classnames';
import { Button, ValidationForm } from '../../atoms';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  fetchBuyerConvenors,
  fetchBuyers,
  fetchBuyerSuperconvenors,
} from '../../../store/buyerAPI/buyer/reducers/buyer.slice';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';
import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeSupportersResponseDto } from '../../../store/tradeAPI/commodity/dto/response/landscape-suporters-response.dto';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';

interface LandscapeAboutCommittedBuyersPartnerOrganismProps {
  callbackFn: (supporter: LandscapeSupportersResponseDto) => void;
  supporter: LandscapeSupportersResponseDto;
  handleOnChange: (supporter: LandscapeSupportersResponseDto) => void;
}

const LandscapeAboutCommittedBuyersPartnerOrganism: FC<
  LandscapeAboutCommittedBuyersPartnerOrganismProps
> = ({ callbackFn, supporter, handleOnChange }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [organizationItems, setOrganizationItems] = useState<DropdownItem[]>();

  const [selectedRelation, setSelectedRelation] =
    useState<LandscapeBuyerRelationType>(LandscapeBuyerRelationType.Funders);

  const { buyers, consortiums, conveners, status } = useSelector(
    (state: RootState) => state.buyerSlice
  );

  const relationTypes = Object.values(LandscapeBuyerRelationType);

  const relations: DropdownItem[] = relationTypes.map((type) => ({
    eventKey: type.toString(),
    label: type.toString(),
  }));

  useEffect(() => {
    dispatch(fetchBuyers());
    dispatch(fetchBuyerConvenors());
    dispatch(fetchBuyerSuperconvenors());
  }, [dispatch]);

  useEffect(() => {
    if (
      selectedRelation === LandscapeBuyerRelationType.Funders ||
      selectedRelation === LandscapeBuyerRelationType.CoalitionPartners ||
      selectedRelation === LandscapeBuyerRelationType.BuyerConveners ||
      selectedRelation === LandscapeBuyerRelationType.BuyerImplementers
    ) {
      mapOrganizationsToItems(buyers ?? []);
    } else if (selectedRelation === LandscapeBuyerRelationType.Consortiums) {
      mapOrganizationsToItems(consortiums ?? []);
    } else if (selectedRelation === LandscapeBuyerRelationType.Conveners) {
      mapOrganizationsToItems(conveners ?? []);
    }
  }, [selectedRelation, buyers, consortiums, conveners]);

  const mapOrganizationsToItems = (organizations: BuyerResponseDto[]) => {
    const items = organizations.map((organization) => ({
      eventKey: organization.id,
      label: organization.name ?? '',
    }));
    setOrganizationItems(items);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <ValidationForm onSubmitCallback={() => callbackFn(supporter)}>
      <div className={cn(styles.wrapper)}>
        <Form.Group className="mb-3">
          <Form.Label>Relation type</Form.Label>
          <CustomDropdown
            initialTitle={
              supporter.relationType ?? LandscapeBuyerRelationType.Funders
            }
            items={relations}
            onSelectOption={(item) => {
              // const selectedType = relations?.find(
              //   (type) => type.eventKey === item.eventKey
              // )!.eventKey;
              const selectedType =
                LandscapeBuyerRelationType[
                  item.eventKey as keyof typeof LandscapeBuyerRelationType
                ];
              setSelectedRelation(selectedType);
              handleOnChange({
                ...supporter,
                relationType: selectedType,
              });
            }}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Organization</Form.Label>
          <CustomDropdown
            initialTitle={'Choose organization'}
            items={organizationItems ?? []}
            onSelectOption={(e) => {
              handleOnChange({
                ...supporter,
                organizationId: e.eventKey,
              });
            }}
          />
        </Form.Group>

        <Button variant="dark" type="submit">
          Save
        </Button>
      </div>
    </ValidationForm>
  );
};

export default LandscapeAboutCommittedBuyersPartnerOrganism;
